import { z } from 'zod';

import { mongoIdSchema } from './shared';

export const aiPromptCreateSchema = z.object({
  organizationId: mongoIdSchema.nullish(),
  brandId: mongoIdSchema.nullish(),
  userId: mongoIdSchema.nullish(),
  name: z.string(),
  instruction: z.string(),
});
export type AiPromptCreate = z.infer<typeof aiPromptCreateSchema>;

export const aiPromptSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(aiPromptCreateSchema);

export type AiPrompt = z.infer<typeof aiPromptSchema>;
